// Import a polyfill for node.remove() (IE)
import '../../vendor/polyfills/polyfill-remove.js';

import isIterable from '../is-iterable/u-is-iterable.js';

// Detach elements and create a placeholder
function detachWithPlaceholder (elements) {
	if (!isIterable(elements)) {
		elements = [elements];
	}
	for (let element of elements) {
		if (!element.detachedPlaceholder) {
			let placeholder = document.createElement('span');
			placeholder.setAttribute('style', 'position: absolute; top: -99999, left: -99999;');
			element.parentNode.insertBefore(placeholder, element.nextSibling);
			element.detachedPlaceholder = placeholder;
			element.remove();
		}
	}
}

// Replace placeholders with their owner element and remove placeholders
function attachToPlaceholder (elements) {
	if (!isIterable(elements)) {
		elements = [elements];
	}
	for (let element of elements) {
		let placeholder = element.detachedPlaceholder;
		if (placeholder) {
			if (Element.prototype.replaceWith) {
				placeholder.replaceWith(element);
			}
			else {
				placeholder.parentNode.replaceChild(element, placeholder);
			}
			element.detachedPlaceholder = null;
			placeholder.remove();
		}
	}
}

export {detachWithPlaceholder};
export {attachToPlaceholder};

export default {detachWithPlaceholder, attachToPlaceholder};


// WEBPACK FOOTER //
// ./js/utilities/detach-with-placeholder/u-detach-with-placeholder.js